import { createRouter, createWebHistory } from 'vue-router';
import { useAuthStore } from '../stores/authStore';
import Login from '../pages/Login.vue';
import Trades from '../pages/Trades.vue';
import Claims from '../pages/Claims.vue';
import Analyses from '../pages/Analyses.vue';
import Settings from '../pages/Settings.vue';
import Weather from '../pages/Weather.vue';
import Metas from '../pages/Metas.vue';
import Simulation from '../pages/Simulation.vue';

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: { requiresAuth: false }
  },
  // ── Páginas novas (redesign) ──────────────────────────────
  {
    path: '/ao-vivo',
    name: 'AoVivo',
    component: () => import('../pages/AoVivo.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/',
    name: 'Overview',
    component: () => import('../pages/Overview.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/crypto',
    name: 'Crypto',
    component: () => import('../pages/Crypto.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/futebol',
    name: 'Combos',
    component: () => import('../pages/Combos.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/tweets',
    name: 'Tweets',
    component: () => import('../pages/Tweets.vue'),
    meta: { requiresAuth: true }
  },
  // ── Páginas antigas (mantidas) ────────────────────────────
  {
    path: '/trades',
    name: 'Trades',
    component: Trades,
    meta: { requiresAuth: true }
  },
  {
    path: '/claims',
    name: 'Claims',
    component: Claims,
    meta: { requiresAuth: true }
  },
  {
    path: '/analyses',
    name: 'Analyses',
    component: Analyses,
    meta: { requiresAuth: true }
  },
  {
    path: '/simulacoes',
    name: 'Simulation',
    component: Simulation,
    meta: { requiresAuth: true }
  },
  {
    path: '/weather',
    name: 'Weather',
    component: Weather,
    meta: { requiresAuth: true }
  },
  {
    path: '/metas',
    name: 'Metas',
    component: Metas,
    meta: { requiresAuth: true }
  },
  {
    path: '/settings',
    name: 'Settings',
    component: Settings,
    meta: { requiresAuth: true }
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/login'
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes
});

router.beforeEach((to, from, next) => {
  const authStore = useAuthStore();
  const requiresAuth = to.meta.requiresAuth !== false;

  if (to.name === 'Login') {
    next();
    return;
  }

  if (requiresAuth && !authStore.isAuthenticated) {
    authStore.restoreSession();
  }

  if (requiresAuth && !authStore.isAuthenticated) {
    next({
      name: 'Login',
      query: { redirect: to.fullPath }
    });
    return;
  }

  next();
});

export default router;
